/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type JSX } from 'react';

import { ReportsView } from '../reports/reports-view.js';

/** Finance → Reports (Figma). Same report surface as Admin. */
export function FinanceReportsPage(): JSX.Element {
  return <ReportsView titleKey="finance.reports.title" subtitleKey="finance.reports.count" />;
}
